<template>
  <div :class="classes">
    <div :class="headerClasses" @click="$_toggle">
      <t-icon :icon="icon"></t-icon>
      <slot></slot>
    </div>
    <t-collapse-transition>
      <div v-show="active" :class="contentClasses">
        <div :class="boxClasses" :style="padding">
          <slot name="content"></slot>
        </div>
      </div>
    </t-collapse-transition>
  </div>
</template>

<script>
import { PREFIX_CLASS } from '../../utils/constants'
import TIcon from '../icon'

const PREFIX_CLS = `${PREFIX_CLASS}collapse`
export default {
  name: 'TCollapsePanel',
  components: {
    TIcon
  },
  props: {
    name: {
      type: [String, Number],
      default: ''
    },
    compact: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      index: 0,
      active: false,
      padding: {}
    }
  },
  computed: {
    classes() {
      return [
        `${PREFIX_CLS}-panel`,
        {
          [`${PREFIX_CLS}-panel-active`]: this.active
        }
      ]
    },
    headerClasses() {
      return `${PREFIX_CLS}-panel-header`
    },
    contentClasses() {
      return `${PREFIX_CLS}-panel-block`
    },
    boxClasses() {
      return `${PREFIX_CLS}-content-box`
    },
    icon() {
      if (this.$parent && this.$parent.type === 'borderless') {
        return this.active ? 'menu-down-outline' : 'menu-right-outline'
      }
      return this.active ? 'chevron-down-outline' : 'chevron-right-outline'
    }
  },
  watch: {
    active(newVal) {
      if (this.compact && newVal) {
        this.padding = {
          padding: 0
        }
      }
    }
  },
  methods: {
    $_toggle() {
      this.$parent.toggleCollapse({
        name: this.name || this.index,
        active: this.active
      })
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/module/collapse/collapse-panel.vue